// Should be the same as the one set in the css variable --c-header-logo-max-width
export const LOGO_MAX_WIDTH = 300 // px
// Should be the same as the one set in the css variable --c-header-logo-max-height
export const LOGO_MAX_HEIGHT = 40 // px
